// TRIAD theme behaviour (from the prototype's site.js; cart, forms and hours are the Shopify versions). Content works without it; this only adds motion and conveniences.
document.documentElement.classList.add('js');
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
// ---- draft-theme preview: the new pages stay hidden (404) until launch, so links to them borrow the visible
// Sample TRIAD page and ask for the page's template instead. Never runs once this theme is the live one.
if (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') {
  const views = { shop: 'shop', brands: 'brands', 'free-services': 'free-services', 'sample-triad': 'sample-triad', about: 'about', locations: 'locations',
    order: 'order', learn: 'learn', contact: 'contact', 'north-okc': 'store', edmond: 'store-edmond', yukon: 'store-yukon', norman: 'store-norman' };
  document.querySelectorAll('a[href^="/pages/"]').forEach(a => {
    const u = new URL(a.href), v = views[u.pathname.split('/')[2]];
    if (v) { u.pathname = '/pages/sample-triad'; u.searchParams.set('view', v); a.href = u.pathname + u.search + u.hash; }
  });
}
const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

// ---- overlays: menu + cart share one scroll lock and one "rest of page is inert" switch ----
const header = $('.site-header'), nav = $('.nav'), menuBtn = $('.menu-btn');
const cartEl = $('.cart'), scrim = $('.cart-scrim'), cartBtn = $('.cart-btn');
const behindMenu = [$('main'), $('.site-footer')], behindCart = [header, $('main'), $('.site-footer')];
function syncOverlays() {
  const menu = nav.classList.contains('open'), cart = cartEl.classList.contains('open');
  document.body.style.overflow = menu || cart ? 'hidden' : '';
  document.body.classList.toggle('menu-open', menu);
  behindCart.forEach(el => el && (el.inert = cart));
  if (!cart) behindMenu.forEach(el => el && (el.inert = menu));
}
function openMenu(open) {
  nav.classList.toggle('open', open); menuBtn.setAttribute('aria-expanded', open);
  menuBtn.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
  syncOverlays();
  if (open) $('a', nav)?.focus();
}
menuBtn?.addEventListener('click', () => openMenu(!nav.classList.contains('open')));
addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  if (cartEl.classList.contains('open')) openCart(false);
  else if (nav.classList.contains('open')) { openMenu(false); menuBtn.focus(); }
});
matchMedia('(min-width: 981px)').addEventListener('change', m => { if (m.matches && nav.classList.contains('open')) openMenu(false); });

// ---- open now: all stores share one schedule (Theme settings › Hours), in Oklahoma time; refreshed every minute and when the tab returns ----
// "9am – 9pm" -> [9, 21]; "11:30am – 7pm" -> [11.5, 19]; anything without two times (e.g. "Closed") -> null
const toH = (n, m, ap) => (+n % 12) + (ap.toLowerCase() === 'pm' ? 12 : 0) + (m ? +m / 60 : 0);
const HOURS = (window.TRIAD?.hours || []).map(t => {
  const m = [...String(t || '').matchAll(/(\d{1,2})(?::(\d{2}))?\s*(am|pm)/gi)];
  return m.length === 2 ? [toH(m[0][1], m[0][2], m[0][3]), toH(m[1][1], m[1][2], m[1][3])] : null;
});
function okNow() {
  const p = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
    .formatToParts(new Date()).map(x => [x.type, x.value]));
  return { day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday), h: +p.hour + p.minute / 60 };
}
const article = w => /^[aeiou]/i.test(w) ? 'an' : 'a';
const fmt = h => { const hh = Math.floor(h), mm = Math.round((h - hh) * 60); return (hh % 12 || 12) + (mm ? ':' + String(mm).padStart(2, '0') : '') + (hh >= 12 ? 'pm' : 'am'); };
function refreshHours() {
  if (HOURS.length !== 7) return;
  const { day, h } = okNow(), today = HOURS[day], open = !!today && h >= today[0] && h < today[1];
  let text = 'Open now · until ' + (today ? fmt(today[1]) : '');
  if (!open) {
    // the next opening: later today, else the next day that has hours
    let next = '';
    if (today && h < today[0]) next = 'today ' + fmt(today[0]);
    else for (let k = 1; k <= 7; k++) { const d = HOURS[(day + k) % 7]; if (d) { next = (k === 1 ? 'tomorrow ' : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][(day + k) % 7] + ' ') + fmt(d[0]); break; } }
    text = 'Closed' + (next ? ' · opens ' + next : '');
  }
  $$('[data-open]').forEach(el => { el.textContent = text; el.classList.toggle('is-open', open); });
  $$('.hours tr').forEach(tr => tr.classList.toggle('today', +tr.dataset.day === day));
}
refreshHours(); setInterval(refreshHours, 60000);
document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshHours(); });

// ---- reveal on scroll ----
if (!reduce && 'IntersectionObserver' in window) {
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
  $$('.rv, .cat').forEach(el => io.observe(el));
} else $$('.rv, .cat').forEach(el => el.classList.add('in'));

// ---- header solid on scroll + home hero drift ----
const hero = $('.hero'), hImg = $('.hero-img'), hH1 = $('.hero h1');
const mbar = $('.mbar');
function frame() {
  header?.classList.toggle('solid', scrollY > 40);
  if (mbar && hero) mbar.classList.toggle('show', scrollY > hero.offsetHeight * 0.6);
  if (hero && !reduce) {
    const y = Math.min(scrollY, hero.offsetHeight);
    hImg.style.transform = `translateY(${y * .3}px) scale(${1 + y / 2400})`;
    hH1.style.transform = `translateY(${-y * .18}px)`; hH1.style.opacity = 1 - y / (hero.offsetHeight * 1.1);
  }
}
let raf = 0;
addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; frame(); catFrame(); }); }, { passive: true });
addEventListener('resize', frame); frame();

// ---- home: hero video. Each screen loads only its own cut; reduced motion keeps the still photo ----
const vid = $('.hero-vid');
// started once the still photo has loaded, so the headline and the still paint first on a phone. Not on window
// 'load': on Shopify the analytics and app scripts hold that back by seconds, which pushed LCP to ~11 s.
const still = $('.hero picture img');
if (vid && !reduce) {
  const go = () => setTimeout(startHeroVideo, 300);
  if (!still || still.complete) go(); else { still.addEventListener('load', go, { once: true }); still.addEventListener('error', go, { once: true }); }
}
function startHeroVideo() {
  const phone = matchMedia('(max-width: 640px)').matches;
  vid.poster = phone ? vid.dataset.posterPhone : vid.dataset.posterDesktop;
  vid.src = phone ? vid.dataset.phone : vid.dataset.desktop;
  vid.addEventListener('playing', () => vid.classList.add('playing'), { once: true });
  vid.play().catch(() => {});
  // pause when the hero is off screen, to save battery
  new IntersectionObserver(([e]) => e.isIntersecting ? vid.play().catch(() => {}) : vid.pause()).observe(vid);
}

// ---- home: aisle index, hovering a category swaps the shelf photo and caption ----
const aisleLinks = $$('.aisle-index a'), aisleImgs = $$('.viewer img');
aisleLinks.forEach(a => ['mouseenter', 'focus'].forEach(ev => a.addEventListener(ev, () => {
  aisleLinks.forEach(l => l.classList.toggle('on', l === a));
  aisleImgs.forEach(i => i.classList.toggle('on', i.dataset.k === a.dataset.k));
  $('.cap-n').textContent = a.dataset.name;
  $('.cap-b').textContent = +a.dataset.n ? `${a.dataset.n} brands on the shelf` : 'Ask a certified coach what fits your plan';
})));

// ---- brand logos: explicit pause (touch and keyboard users can't hover) ----
$('.marquee-toggle')?.addEventListener('click', e => {
  const b = e.currentTarget, paused = b.getAttribute('aria-pressed') !== 'true';
  b.setAttribute('aria-pressed', paused); b.textContent = paused ? 'Play' : 'Pause';
  $('.brandband').classList.toggle('paused', paused);
});

// ---- shop page: highlight the category in view (the last one whose top has passed mid-screen) ----
const catLinks = $$('.cat-nav a'), cats = $$('.cat');
let catOn = -1;
function catFrame() {
  if (!catLinks.length) return;
  let i = 0;
  cats.forEach((c, j) => { if (c.getBoundingClientRect().top < innerHeight * .5) i = j; });
  if (i === catOn) return; catOn = i;
  catLinks.forEach((a, j) => a.classList.toggle('on', j === i));
  const bar = catLinks[i].parentElement;
  bar.scrollTo({ left: catLinks[i].offsetLeft - bar.clientWidth / 2 + catLinks[i].offsetWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
}
catFrame();

// ---- store pages: the map loads only when asked for (saves ~440 KB of Google scripts) ----
$$('[data-map]').forEach(b => b.addEventListener('click', () => {
  const f = document.createElement('iframe');
  Object.assign(f, { className: 'map', title: b.dataset.title, src: b.dataset.map, loading: 'lazy', referrerPolicy: 'no-referrer-when-downgrade' });
  b.closest('.map-box').replaceChildren(f); f.focus();
}));

// ---- forms: inline errors tied to each field, then Shopify sends the form ----
const qs = new URLSearchParams(location.search);
$$('select[name="contact[Nearest TRIAD]"]').forEach(s => {
  const o = qs.get('store') && $(`option[data-slug="${CSS.escape(qs.get('store'))}"]`, s);
  if (o) s.value = o.value;
});
function setError(el, on) {
  const id = el.id + '-err'; let err = document.getElementById(id);
  el.setAttribute('aria-invalid', on);
  if (on && !err) {
    err = Object.assign(document.createElement('p'), { id, className: 'err' });
    el.after(err); el.setAttribute('aria-describedby', id);
  }
  if (err) { err.textContent = on ? (el.type === 'email' && el.value ? 'That email doesn’t look right. Try name@example.com.' : el.dataset.msg || 'Fill in this field.') : ''; err.hidden = !on; }
}
$$('form.form').forEach(f => {
  if (f.matches('.search-form')) return;
  f.addEventListener('submit', e => {
    const fields = $$('input,select,textarea', f).filter(el => el.type !== 'hidden');
    const bad = fields.filter(el => !el.checkValidity());
    fields.forEach(el => el.hasAttribute('aria-invalid') && setError(el, false));
    bad.forEach(el => setError(el, true));
    if (bad.length) { e.preventDefault(); bad[0].focus(); return; }
    // remember the store for the thank-you line after Shopify reloads the page
    const store = $('select[name="contact[Nearest TRIAD]"]', f);
    try { if (store) sessionStorage.setItem('triad-store', store.value); } catch {}
    $('button[type=submit]', f)?.setAttribute('aria-disabled', 'true');
  });
  f.addEventListener('input', e => { if (e.target.getAttribute('aria-invalid') === 'true' && e.target.checkValidity()) setError(e.target, false); });
  // after a successful send, Shopify reloads the page: show the thank-you in place of the fields
  const msg = $('.sent[data-posted]', f);
  if (msg) {
    let store = ''; try { store = sessionStorage.getItem('triad-store') || ''; sessionStorage.removeItem('triad-store'); } catch {}
    if (store && msg.dataset.store) msg.textContent = msg.dataset.store.replace('{store}', store);
    f.classList.add('done'); msg.scrollIntoView({ block: 'center' }); msg.focus({ preventScroll: true });
  }
});

// ---- merch filter: a chip shows products whose tags or type match it ----
$$('.chip').forEach(c => c.addEventListener('click', () => {
  $$('.chip').forEach(x => { x.classList.toggle('on', x === c); x.setAttribute('aria-pressed', x === c); });
  const shown = $$('.prods .prod').filter(p => !(p.hidden = c.dataset.f !== 'all' && !p.dataset.tags.split(' ').includes(c.dataset.f))).length;
  $('#merch-count').textContent = `Showing ${shown} item${shown === 1 ? '' : 's'}${c.dataset.f === 'all' ? '' : ' in ' + c.textContent}`;
  history.replaceState(null, '', c.dataset.f === 'all' ? location.pathname : '#' + c.id);
}));
const hashChip = location.hash ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null;
if (hashChip && hashChip.matches('.chip')) hashChip.click();

// ---- cart: Shopify's AJAX cart in a drawer. Without JavaScript the cart icon is a link to /cart ----
const money = cents => '$' + (cents % 100 ? (cents / 100).toFixed(2) : cents / 100);
const sized = (u, w) => u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '';
let lastFocus = null;
async function cartCall(path, body) {
  const r = await fetch(path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
  const data = await r.json();
  if (!r.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
  return data;
}
function renderCart(c) {
  const n = c.item_count;
  const cnt = $('.cart-count'); cnt.textContent = n; cnt.hidden = !n;
  cartBtn.setAttribute('aria-label', n ? `Cart, ${n} item${n > 1 ? 's' : ''}` : 'Cart');
  cartEl.classList.toggle('has', n > 0);
  $('.cart-items').innerHTML = c.items.map(i => `<div class="ci-row">${i.image ? `<img src="${esc(sized(i.image, 160))}" alt="" width="72" height="72">` : '<span></span>'}<div><b>${esc(i.product_title)}</b><small>${i.product_has_only_default_variant ? '' : esc(i.variant_title) + ' · '}Qty ${+i.quantity}</small><br><button class="rm" data-key="${esc(i.key)}" aria-label="Remove ${esc(i.product_title)}">Remove</button></div><span class="p">${money(i.final_line_price)}</span></div>`).join('');
  $('.cart-total').textContent = money(c.total_price);
}
const refreshCart = () => cartCall('/cart.js').then(renderCart).catch(() => {});
function openCart(open) {
  if (open && nav.classList.contains('open')) openMenu(false);
  cartEl.classList.toggle('open', open); cartEl.setAttribute('aria-hidden', !open); scrim.hidden = !open;
  cartBtn.setAttribute('aria-expanded', open);
  syncOverlays();
  if (open) { lastFocus = document.activeElement; $('.cart-close').focus(); } else (lastFocus || cartBtn).focus();
}
cartBtn.addEventListener('click', e => { e.preventDefault(); openCart(true); });
$('.cart-close').addEventListener('click', () => openCart(false));
scrim.addEventListener('click', () => openCart(false));
$('.cart-items').addEventListener('click', async e => {
  const b = e.target.closest('.rm'); if (!b) return;
  const k = $$('.cart-items .rm').indexOf(b);
  b.disabled = true;
  try { renderCart(await cartCall('/cart/change.js', { id: b.dataset.key, quantity: 0 })); }
  catch (err) { $('.cart-note').textContent = err.message; b.disabled = false; return; }
  const rms = $$('.cart-items .rm');
  (rms[Math.min(k, rms.length - 1)] || $('.cart-close')).focus();
});
refreshCart();
// back/forward cache can show a stale count
addEventListener('pageshow', e => { if (e.persisted) refreshCart(); });

// ---- product page: native radios; values with no variant in stock (given the other choice) are disabled ----
const info = $('.pinfo');
if (info) {
  const P = JSON.parse(info.dataset.product), pick = Array(P.nopts).fill(null);
  const form = $('form', info), idInput = $('input[name=id]', info);
  const addBtn = $('.add', info), stock = $('.stock', info), priceEl = $('.pprice'), qty = $('.qty input', info);
  const dollars = x => '$' + (Number.isInteger(x) ? x : x.toFixed(2));
  const match = () => P.vars.find(v => v.opts.every((o, i) => o === pick[i]));
  function update() {
    $$('.opt input', info).forEach(inp => {
      const o = +inp.dataset.o;
      const ok = P.vars.some(v => v.ok && v.opts[o] === inp.value && v.opts.every((x, i) => i === o || pick[i] === null || x === pick[i]));
      if (!ok && inp.checked) { inp.checked = false; pick[o] = null; }
      inp.disabled = !ok; inp.closest('.opt').classList.toggle('na', !ok);
    });
    $$('.opts', info).forEach((f, i) => $('.optval', f).textContent = pick[i] ?? `Choose ${article(P.names[i])} ${P.names[i].toLowerCase()}`);
    const v = P.nopts ? (pick.every(x => x !== null) ? match() : null) : P.vars[0];
    if (v) { priceEl.textContent = dollars(v.price); idInput.value = v.id; }
    if (!P.vars.some(x => x.ok)) { addBtn.disabled = true; addBtn.textContent = 'Sold out online'; stock.textContent = 'Check your store: it may be on the rack.'; return; }
    if (!v) { const nm = P.names[pick.findIndex(x => x === null)]; addBtn.disabled = true; addBtn.textContent = `Choose ${article(nm)} ${nm.toLowerCase()}`; stock.textContent = ''; return; }
    addBtn.disabled = !v.ok; addBtn.textContent = v.ok ? 'Add to cart' : 'Sold out online';
    stock.textContent = v.ok ? '' : 'This option is sold out online. Check your store.';
  }
  $$('.opt input', info).forEach(inp => inp.addEventListener('change', () => { pick[+inp.dataset.o] = inp.value; update(); }));
  const clampQty = () => { qty.value = Math.min(10, Math.max(1, Math.round(+qty.value) || 1)); };
  $$('.qty button', info).forEach(b => b.addEventListener('click', () => { qty.value = (+qty.value || 1) + +b.dataset.q; clampQty(); }));
  qty.addEventListener('change', clampQty);
  form.addEventListener('submit', async e => {
    e.preventDefault();
    const v = P.nopts ? match() : P.vars[0]; if (!v || !v.ok) return;
    clampQty(); addBtn.disabled = true; stock.textContent = '';
    try { await cartCall('/cart/add.js', { items: [{ id: v.id, quantity: +qty.value }] }); renderCart(await cartCall('/cart.js')); openCart(true); }
    catch (err) { stock.textContent = err.message; }
    addBtn.disabled = false;
  });
  $$('.thumb').forEach(t => t.addEventListener('click', () => {
    const g = $('#gmain'); g.removeAttribute('srcset'); g.src = t.dataset.src;
    $$('.thumb').forEach(x => { x.classList.toggle('on', x === t); x.setAttribute('aria-pressed', x === t); });
  }));
  update();
}

// ---- phone layout: footer groups start folded; long brand lists open on request ----
const phoneMq = matchMedia('(max-width: 560px)');
const foldFooter = () => $$('details.fcol').forEach(d => { d.open = !phoneMq.matches; });
foldFooter(); phoneMq.addEventListener('change', foldFooter);
$$('.pills-more').forEach(b => b.addEventListener('click', () => {
  const pills = b.previousElementSibling; pills.classList.remove('clip'); b.remove();
  const next = pills.querySelector('span:nth-child(11)');
  if (next) { next.tabIndex = -1; next.focus(); }
}));
// on desktop the footer groups stay open: their headings are labels, not toggles
$$('details.fcol>summary').forEach(s => s.addEventListener('click', e => { if (!phoneMq.matches) e.preventDefault(); }));
